/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const loadingHolderDetailConfig = {
  loading: {
    loadingProfile: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Retrieving ',
      titleBoldText: 'Policy holder profile...',
      description: 'This might take few seconds, Please wait !',
    },
    updateKycStatus: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Updating',
      titleBoldText: 'Know Your Customer (KYC) status...',
      description: 'This might take few seconds, Please wait !',
    },
    policyList: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/fhp_loading_illustration_2.png',
      titleNormalText: 'Loading',
      titleBoldText: 'Policy list...',
      description: 'This might take few seconds, Please wait !',
    },
    credentialListEmpty: {
      image:
        'https://s3.ap-south-1.amazonaws.com/io.vlinder.illustrations/resting_black.png',
      titleNormalText: 'No policies found',
      titleBoldText: 'yet',
      description: 'policy purchased by holder will list here.',
    },
  },
};
